var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16H9C9.26512 15.9997 9.5193 15.8942 9.70677 15.7068C9.89424 15.5193 9.9997 15.2651 10 15V13.5H9V15H3V3H9V4.5H10V3C9.9997 2.73488 9.89424 2.4807 9.70677 2.29323C9.5193 2.10576 9.26512 2.0003 9 2H3C2.73488 2.0003 2.4807 2.10576 2.29323 2.29323C2.10576 2.4807 2.0003 2.73488 2 3V15C2.0003 15.2651 2.10576 15.5193 2.29323 15.7068C2.4807 15.8942 2.73488 15.9997 3 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 11.293L12.086 9.5H5V8.5H12.086L10.293 6.707L11 6L14 9L11 12L10.293 11.293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogout);
export default __webpack_public_path__ + "static/media/nav_logout.ee8ab39f00f718a293408e8cad96b04a.svg";
export { ForwardRef as ReactComponent };